/**
 * Hiển thị kèm theo (mẫu 07)
 */
export default {
  All: 'All', //'Tất cả'
  BUPlanWithdraw: 'BUPlanWithdraw', //'Giấy rút dự toán'
  Accreditative: 'Accreditative', //'Ủy nhiệm chi'
  AdvancePaymentRequestLetter: 'AdvancePaymentRequestLetter', //'Giấy đề nghị thanh toán tạm ứng'
  NoSelect: 'NoSelect', //'Không chọn'
};
